exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "seo .icon-19 {\n  font-size: 19px;\n  height: 19px;\n  width: 19px;\n  line-height: 19px;\n  min-width: 19px;\n  min-height: 19px;\n  user-select: none;\n}", ""]);

// exports
